module.exports = __webpack_public_path__ + "assets/img/store-3.0a92c2cd.png";